type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export default function SearchIcon({ className, ...props }: Props) {
  return (
    <svg
      {...props}
      className={className}
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.02105 12.0411C4.83029 12.0411 3.66628 11.688 2.6762 11.0265C1.68613 10.3649 0.91446 9.42464 0.458778 8.32452C0.00309685 7.22441 -0.11613 6.01388 0.116174 4.84601C0.348479 3.67813 0.921881 2.60537 1.76387 1.76338C2.60586 0.921393 3.67862 0.34799 4.84649 0.115686C6.01437 -0.116618 7.2249 0.00260857 8.32501 0.45829C9.42513 0.913972 10.3654 1.68564 11.027 2.67572C11.6885 3.66579 12.0416 4.8298 12.0416 6.02056C12.0416 6.81119 11.8859 7.59408 11.5833 8.32452C11.2808 9.05497 10.8373 9.71867 10.2782 10.2777C9.71916 10.8368 9.05546 11.2803 8.32501 11.5828C7.59457 11.8854 6.81168 12.0411 6.02105 12.0411ZM6.02105 1.20731C5.07224 1.20731 4.14474 1.48867 3.35583 2.0158C2.56693 2.54292 1.95205 3.29215 1.58896 4.16874C1.22587 5.04532 1.13087 6.00989 1.31597 6.94046C1.50107 7.87104 1.95797 8.72583 2.62887 9.39674C3.29978 10.0676 4.15457 10.5245 5.08515 10.7096C6.01572 10.8947 6.98029 10.7997 7.85688 10.4367C8.73346 10.0736 9.48269 9.45868 10.0098 8.66978C10.5369 7.88088 10.8183 6.95337 10.8183 6.00457C10.8183 4.73226 10.3129 3.51206 9.41322 2.6124C8.51356 1.71274 7.29336 1.20731 6.02105 1.20731Z"
        fill="currentcolor"
      />
      <path
        d="M13.401 14C13.3222 14.0003 13.2441 13.985 13.1713 13.9548C13.0986 13.9246 13.0326 13.8801 12.9772 13.8241L9.6751 10.522C9.56918 10.4083 9.51151 10.2579 9.51425 10.1026C9.51699 9.94723 9.57993 9.79901 9.6898 9.68914C9.79966 9.57927 9.94789 9.51634 10.1032 9.5136C10.2586 9.51086 10.4089 9.56852 10.5226 9.67445L13.8247 12.9766C13.937 13.089 14.0001 13.2414 14.0001 13.4003C14.0001 13.5592 13.937 13.7116 13.8247 13.8241C13.7694 13.8801 13.7034 13.9246 13.6306 13.9548C13.5578 13.985 13.4798 14.0003 13.401 14Z"
        fill="currentcolor"
      />
    </svg>
  );
}
